module.exports = {
  "pc.activity.ended": "已结束",
  "pc.activity.join_now": "马上参加",
  "pc.activity.new_year_opening_bonus": "新年开市红包等你拿",
  "pc.activity.ongoing": "进行中",
  "pc.activity.special_offers": "优惠专区",
  "pc.activity.view_event": "查看活动",
  "pc.agency.agent_level": "代理级别",
  "pc.agency.agent_level1": "一级代理",
  "pc.agency.agent_level2": "二级代理",
  "pc.agency.agent_level3": "三级代理",
  "pc.agency.all_members": "所有会员",
  "pc.agency.click_link_to_register": "方法二:点链接注册",
  "pc.agency.commision_share": "佣金分成",
  "pc.agency.commision_transfer": "佣金划转",
  "pc.agency.commission_balance": "佣金余额",
  "pc.agency.commission_withdrawal": "佣金提现",
  "pc.agency.copied": "复制成功",
  "pc.agency.copy_link": "复制链接",
  "pc.agency.deferred_fee_commission": "递延费佣金",
  "pc.agency.deferred_fee_details": "递延费明细",
  "pc.agency.enter_referral_code_when_registering": "方法三:注册时填入推荐代码",
  "pc.agency.first_deposit_amount": "首充金额",
  "pc.agency.friend_single_recharge": "好友单次充值满",
  "pc.agency.from_agent_account": "从代理账户",
  "pc.agency.invite_friends_scanning_qr": "方法一：邀请好友扫描二维码注册",
  "pc.agency.invite_friends_to_register": "通过以下三种方法邀请好友注册",
  "pc.agency.level1_membership": "一级会员",
  "pc.agency.level2_membership": "二级会员",
  "pc.agency.level3_membership": "三级会员",
  "pc.agency.management_fee_commission": "管理费佣金",
  "pc.agency.management_fee_details": "管理费明细",
  "pc.agency.member_level": "会员等级",
  "pc.agency.member_name": "会员名",
  "pc.agency.member_recharge_reward_details": "会员充值奖励明细",
  "pc.agency.membership": "会员",
  "pc.agency.membership_number": "会员号",
  "pc.agency.mobile_number": "手机号",
  "pc.agency.my_commission": "我的佣金",
  "pc.agency.my_membership": "我的会员",
  "pc.agency.my_promotions": "我的推广",
  "pc.agency.no_recharge_membership": "无充值会员",
  "pc.agency.number": "编号",
  "pc.agency.only_one_person_can_use_it": "只限一人使用",
  "pc.agency.person": "人",
  "pc.agency.please_enter_correct_amount": "请输入正确金额",
  "pc.agency.please_enter_transfer_amount": "请填写划转金额",
  "pc.agency.please_enter_withdrawal_amount": "请填写提现金额",
  "pc.agency.please_enter_withdrawal_password": "请输入提现密码",
  "pc.agency.profit_share_details": "利润分成明细",
  "pc.agency.profit_sharing": "利润分成",
  "pc.agency.recharge_membership": "充值会员",
  "pc.agency.scan_qr_code_to_register": "方法一:扫二维码注册",
  "pc.agency.status": "地位",
  "pc.agency.to_principal_account": "到本金账户",
  "pc.agency.today_member": "今日会员",
  "pc.agency.total_deposit": "充值总额",
  "pc.agency.total_withdrawal": "提取总额",
  "pc.agency.transfer": "划转",
  "pc.agency.transfer_amount": "划转金额",
  "pc.agency.withdrawal_starts_from_100yuan": "提现100元起",
  "pc.agency.withdrawal_transfer": "提现划转",
  "pc.agency.you_can_withdraw": "元即可提现",
  "pc.allhkstock.all_us_stocks": "全部美股",
  "pc.allhkstock.change": "涨跌额",
  "pc.allhkstock.code": "代码",
  "pc.allhkstock.code_name_abbreviation": "代码/名称/简拼",
  "pc.allhkstock.highest_price": "最高",
  "pc.allhkstock.latest_price": "最新价",
  "pc.allhkstock.lowest_price": "最低",
  "pc.allhkstock.market_center": "行情中心",
  "pc.allhkstock.name": "名称",
  "pc.allhkstock.opening_price": "今开",
  "pc.allhkstock.rate_of_change": "涨跌幅",
  "pc.allhkstock.us_stock_market": "美股股市",
  "pc.allhkstock.us_stock_market_time": "美股时间:",
  "pc.capital.amount_to_be_deposited": "到账金额",
  "pc.capital.bank": "银行卡管理",
  "pc.capital.bank_account": "开户姓名:",
  "pc.capital.bank_branch": "开户支行",
  "pc.capital.bank_card": "银行卡号:",
  "pc.capital.bank_name": "银行名称",
  "pc.capital.bind_bank_card": "绑定银行卡",
  "pc.capital.card_number": "卡号",
  "pc.capital.daily_limit_automatic_deposits": "自动入款每天限额",
  "pc.capital.decimal_amount_must_match_displayed_system": "（须带小数与系统显示金额一致）",
  "pc.capital.deposit_address": "充值地址",
  "pc.capital.deposit_channel_digital_currency_usdt": "充值通道 数字货币-USDT(TRC20)",
  "pc.capital.deposit_desc1": "请转账后请截图发给在线客服或专属客服确认，申请充值。",
  "pc.capital.deposit_desc2": "需等待1-15分钟，整个网络节点上有一定确认数后，才会实际到账。",
  "pc.capital.deposit_qr_code": "充值二维码",
  "pc.capital.digital_currency_usdt_ins1": "1、重复支付、修改金额充值无法到账，概不负责。",
  "pc.capital.digital_currency_usdt_ins2": "2、平台以到账数量为准，到账数量=转账数量-转账数续费。",
  "pc.capital.digital_currency_usdt_ins3": "3、扫描二维码或复制地址充值，仅接受TRC20-USDT。",
  "pc.capital.friendly_reminder": "温馨提醒",
  "pc.capital.friendly_reminder_desc1": "1-部分转账带小数是系统快速判断入款的需要，否则次日到账。举例提交100美元，系统显示100.02美元，请转100.02美元即可到账。",
  "pc.capital.friendly_reminder_desc2": "2-若10分钟内若未入款，请联系在线客服或专属客服。",
  "pc.capital.myaccount": "我的账户",
  "pc.capital.not_match": "两次密码输入不一致",
  "pc.capital.or": "或者",
  "pc.capital.pay_before": "之前付款",
  "pc.capital.payment_countdown": "支付倒计时",
  "pc.capital.payment_time": "付款时间",
  "pc.capital.please": "请在",
  "pc.capital.please_contact_customer_service_for_latest_bank_card": "请您联系在线客服获取最新银行卡。",
  "pc.capital.please_enter_bank_address": "请输入开户行地址",
  "pc.capital.please_enter_verification_code": "请输入验证码",
  "pc.capital.please_enter_your_account_holder_name": "请输入开户人姓名",
  "pc.capital.please_enter_your_bank_branch": "请输入开户行支行",
  "pc.capital.please_enter_your_bank_card_number": "请输入银行卡号",
  "pc.capital.please_enter_your_confirmation_password": "请输入确认密码",
  "pc.capital.please_enter_your_id": "请输入身份证号",
  "pc.capital.please_enter_your_password": "请输入密码",
  "pc.capital.please_enter_your_real_name": "请输入真实姓名",
  "pc.capital.please_fill_correct_amount": "请填写正确金额",
  "pc.capital.please_pay": "请付",
  "pc.capital.recharge": "充值",
  "pc.capital.recharge_ac_name": "账户名称:",
  "pc.capital.recharge_amt": "充值金额: ",
  "pc.capital.recharge_amt_placeholder": "请填写充值金额",
  "pc.capital.recharge_approve": "我已转账 申请充值",
  "pc.capital.recharge_bank_addr": "银行地址:",
  "pc.capital.recharge_cancel": "取消转账",
  "pc.capital.recharge_channel": "充值通道",
  "pc.capital.recharge_deliver": "送",
  "pc.capital.recharge_dollar": "美币",
  "pc.capital.recharge_exchange_amt": "兑换金额:",
  "pc.capital.recharge_exchange_fee": "兑换费用:",
  "pc.capital.recharge_exchange_rate": "兑换费率:",
  "pc.capital.recharge_exchange_ratio": "美币:人民币=",
  "pc.capital.recharge_full": "充值满",
  "pc.capital.recharge_ins": "充值须知：",
  "pc.capital.recharge_ins1": "1、请勿保留旧卡转账，会造成无法充值。",
  "pc.capital.recharge_ins2": "2、请用本人账号自行通过手机/电脑/银行向以下账号转账。",
  "pc.capital.recharge_ins3": "3、转账成功后点“我已转账，申请充值”，平台确认后到账。",
  "pc.capital.recharge_ins4": "4、转账金额须与系统一致，若有小数须带小数，否则次日到账。",
  "pc.capital.recharge_instruction": "充值须知：",
  "pc.capital.recharge_instruction1": "请勿保留旧卡转账，会造成无法充值。",
  "pc.capital.recharge_instruction2": "请务必以券商指定的实时入款卡为准。",
  "pc.capital.recharge_next": "下一步",
  "pc.capital.recharge_next_step": "获取实时入款卡,请自行通过手机/电脑/银行转账",
  "pc.capital.recharge_open": "正在打开支付通道",
  "pc.capital.recharge_pay_amt": "付款金额:",
  "pc.capital.recharge_pay_copy": "复制",
  "pc.capital.recharge_rmb": "人民币",
  "pc.capital.recharge_success": "充值申请成功,尽快完成后续操作,联系客服吧",
  "pc.capital.recharge_tip": "温馨提示",
  "pc.capital.recharge_tip1": "若10分钟内若未入款，请联系在线客服或专属客服。",
  "pc.capital.recharge_type": "充值方式:",
  "pc.capital.recharge_validity": "有效期",
  "pc.capital.recharge_yuan": "元",
  "pc.capital.starting_from_rmb": "人民币起",
  "pc.capital.topup_over_10000_yuan": "充值一万以上",
  "pc.capital.unable_to_access_bank_card_repeatly": "多次获取不到银行卡",
  "pc.capital.verify_yuor_gx": "请核对您的Gxpay ID 后再确认提现操作",
  "pc.capital.withdraw": "提现",
  "pc.capital.withdraw.bankcard_popup_cancel_button": "取消",
  "pc.capital.withdraw.bankcard_popup_confirm_button": "确定",
  "pc.capital.withdraw.bankcard_popup_content": "请先设置提现银行卡才能提现",
  "pc.capital.withdraw.bankcard_popup_title": "提示",
  "pc.capital.withdraw.second_withdraw_popup_content_cancel_button": "转入时时宝",
  "pc.capital.withdraw.second_withdraw_popup_content_confirm_button": "继续提现",
  "pc.capital.withdraw.second_withdraw_popup_content_popup_title": "友情提醒",
  "pc.capital.withdraw.second_withdraw_popup_first_content": "转入时时宝, 每8小时收益",
  "pc.capital.withdraw.second_withdraw_popup_second_content": "开市炒股，休市理财，时时赚钱\n随进随出，实时到账，年化收益率",
  "pc.capital.withdraw1": "请务必用本人 ( ",
  "pc.capital.withdraw2": " ) 名字的银行卡提款!",
  "pc.capital.withdraw_Ac": "请选择提现账号",
  "pc.capital.withdraw_ac_balance": "账户金额:",
  "pc.capital.withdraw_amt": "提现金额:",
  "pc.capital.withdraw_amt_plh": "最少提现100元",
  "pc.capital.withdraw_change_pw": "修改提现密码",
  "pc.capital.withdraw_confirm": "确认提现",
  "pc.capital.withdraw_exchange_rate": "兑换汇率:",
  "pc.capital.withdraw_gx_plh": "请输入Gxpay ID",
  "pc.capital.withdraw_gx_verified": "已核对确认",
  "pc.capital.withdraw_pw": "提现密码:",
  "pc.capital.withdraw_pw_plh": "请填写提现密码",
  "pc.capital.withdraw_type": "提现方式:",
  "pc.capitalcommon.log_first": "请先登录",
  "pc.capitalcommon.please_read_agreement": "请先阅读协议书",
  "pc.common.mobile_format_error": "手机号格式不正确",
  "pc.dealbuy.enter_buy_price": "请输入买入价格",
  "pc.dealbuy.enter_buy_qty": "请输入买入数量",
  "pc.dealbuy.enter_valid_code": "请输入正确的证券代码",
  "pc.dealbuy.securitycode_exsist": "此证券已存在",
  "pc.dealbuy.securitycode_not_exsist": "证券代码不存在",
  "pc.dealsell.enter_sell_price": "请输入卖出价格",
  "pc.dealsell.enter_sell_qty": "请输入卖出数量",
  "pc.dealsell.securitycode_not_exsist": "证券代码不存在",
  "pc.download.android_classic_version": "安卓经典版",
  "pc.download.android_professional_version": "安卓专业版",
  "pc.download.android_upgrate_free_version": "安卓免升级版",
  "pc.download.apple_classic_version": "苹果经典版",
  "pc.download.apple_tf_version": "苹果手机TF版(防封)",
  "pc.download.apple_upgrate_free_version": "苹果免升级版",
  "pc.download.downlod_desc1": "扫描二维码后点击“在App Srote中查看”，安装并打开TestFlight。",
  "pc.download.downlod_desc2": "再次扫描二维码，点金牛港股图标下“开始测试”-“接受”-“安装”按钮，即可使用。",
  "pc.download.downlod_note": "说明：TF全称是testflight，是一种苹果官方的分发模式。",
  "pc.download.windows_desktop": "Windows桌面端",
  "pc.entrust.enter_sell_price": "请输入追加金额",
  "pc.entrust.enter_sell_qty": "请输入追加金额",
  "pc.entrust.securitycode_not_exsist": "请输入提取金额",
  "pc.financefund.enter_amount_incorect": "填写金额不正确",
  "pc.footer.about_us": "关于我们",
  "pc.footer.beginner_guide": "新手指导",
  "pc.footer.business_hours": "工作时间",
  "pc.footer.company_profile": "公司简介",
  "pc.footer.company_qualification": "公司资质",
  "pc.footer.contact_us": "联系我们",
  "pc.footer.faq": "常见问题",
  "pc.footer.help_center": "帮助中心",
  "pc.footer.investment_risky": "（投资有风险，入市需谨慎）",
  "pc.footer.money_with_promotion": "推广赚钱",
  "pc.footer.registration_agreement": "注册协议",
  "pc.footer.service_hotline": "服务电话",
  "pc.footer.statutory_holidays": "法定节日",
  "pc.forgetpass.confirm": "确认",
  "pc.forgetpass.enter_sms_verification_code": "请输入短信验证码",
  "pc.forgetpass.enter_your_card_number": "请输入您的卡",
  "pc.forgetpass.enter_your_new_password": "请输入新密码",
  "pc.forgetpass.enter_your_real_name": "请输入您的真实姓名",
  "pc.forgetpass.get_verification_code": "获取验证码",
  "pc.forgetpass.id_number": "身份证号码",
  "pc.forgetpass.name": "姓名",
  "pc.forgetpass.new_pw_again": "请再次输入新密码",
  "pc.forgetpass.not_match": "两次密码输入不一致",
  "pc.forgetpass.reenter_your_new_password": "再次输入新密码",
  "pc.friendcoupon.details": "详情",
  "pc.friendcoupon.expiration_date": "到期日期",
  "pc.friendcoupon.gift_date": "赠送日期",
  "pc.friendcoupon.instructions_for_use": "使用须知",
  "pc.friendcoupon.promotional_qr_code": "推广二维码/链接",
  "pc.header.about_us": "关于我们",
  "pc.header.activity_zone": "活动专区",
  "pc.header.app_download": "APP下载",
  "pc.header.apply_for_funding": "申请配资",
  "pc.header.bull_stock_diagnosis": "牛股诊股",
  "pc.header.front_page": "首页",
  "pc.header.line1": "线路一",
  "pc.header.line2": "线路二",
  "pc.header.line3": "线路三",
  "pc.header.line_switch": "线路切换",
  "pc.header.login": "登录",
  "pc.header.logout": "退出",
  "pc.header.real_transaction": "做多交易",
  "pc.header.register": "注册",
  "pc.header.short_trade": "做空交易",
  "pc.header.us_stock_account": "美股账户",
  "pc.header.us_stock_market": "美股行情",
  "pc.header.want_to_promote": "我要推广",
  "pc.help.beginners_guide": "新手指引",
  "pc.help.capital_allocation_guide": "配资指南",
  "pc.help.registration_agreement": "注册协议",
  "pc.help.trading_rules": "交易规则",
  "pc.home.100thousand_capital_allocation_actual_profit": "配资10万实盘资金盈利3.5万",
  "pc.home.10thousand_capital_allocation_actual_profit": "配资1万实盘资金盈利0.2万",
  "pc.home.12million_capital_allocation_238000_actual_capital_profit": "配资128万实盘资金盈利23.8万",
  "pc.home.150thousand_capital_allocation_26000_actual_profit": "配资15万实盘资金盈利2.6万",
  "pc.home.150thousand_capital_allocation_actual_profit": "配资15万实盘资金盈利2.79万",
  "pc.home.1million_capital_allocation_156000_actual_capital_profit": "配资150万实盘资金盈利15.6万",
  "pc.home.1million_capital_allocation_158000_actual_capital_profit": "配资130万实盘资金盈利15.8万",
  "pc.home.1million_capital_allocation_238000_actual_capital_profit": "配资140万实盘资金盈利23.8万",
  "pc.home.1million_capital_allocation_actual_capital_profit": "配资150万实盘资金盈利40.5万",
  "pc.home.2million_capital_allocation_actual_capital_profit": "配资200万实盘资金盈利72万",
  "pc.home.3million_capital_allocation_355000_actual_capital_profit": "配资320万实盘资金盈利35.5万",
  "pc.home.3million_capital_allocation_423000_actual_capital_profit": "配资320万实盘资金盈利42.3万",
  "pc.home.3million_capital_allocation_624000_actual_capital_profit": "配资320万实盘资金盈利62.4万",
  "pc.home.3million_capital_allocation_actual_capital_profit": "配资300万实盘资金盈利69万",
  "pc.home.400thousand_capital_allocation_actual_profit": "配资40万实盘资金盈利14万",
  "pc.home.4million_capital_allocation_actual_profit": "配资420万实盘资金盈利85.6万",
  "pc.home.50thousand_capital_allocation_actual_profit": "配资5万实盘资金盈利0.76万",
  "pc.home.5million_capital_allocation_actual_capital_profit": "配资500万实盘资金盈利86万",
  "pc.home.600thousand_capital_allocation_actual_profit": "配资60万实盘资金盈利20.4万",
  "pc.home.60thousand_capital_allocation_12800_actual_profit": "配资6万实盘资金盈利1.28万",
  "pc.home.60thousand_capital_allocation_actual_profit": "配资6万实盘资金盈利0.9万",
  "pc.home.800thousand_capital_allocation_actual_profit": "配资80万实盘资金盈利19.84万",
  "pc.home.880thousand_capital_allocation_actual_profit": "配资88万实盘资金盈利22.88万",
  "pc.home.USD": "美元",
  "pc.home.agent_qq": "代理QQ:",
  "pc.home.alipay": "支付宝",
  "pc.home.announcement": "公告",
  "pc.home.app_download": "app下载",
  "pc.home.baidu": "百度",
  "pc.home.bank_of_china": "中国银行",
  "pc.home.capital_allocation_actual_profit": "配资17万实盘资金盈利1.7万",
  "pc.home.capital_allocation_actual_trading_profit": "配资61万实盘资金盈利4.88万",
  "pc.home.china_merchant_securities": "招商证券",
  "pc.home.china_minsheng_bank": "民生银行",
  "pc.home.citic_securitits": "中信证券",
  "pc.home.click_to_contact_customer_service": "点击联系客服",
  "pc.home.customer_service_qq": "客服QQ:",
  "pc.home.daniu_customer_service": "金牛客服",
  "pc.home.day_capital": "按天配资",
  "pc.home.east_fortune": "东方财富",
  "pc.home.exculusive_gift_for_new_members": "新会员最高专享礼",
  "pc.home.first_deposit_bonus": "首充送",
  "pc.home.free": "全免",
  "pc.home.fund_guarantee": "资金保障",
  "pc.home.fund_guarantee_desc": "资金第三方监管,专款专用",
  "pc.home.funds_are_managed_by_three_parties": "资金三方托管/保险双保障/全实盘交易",
  "pc.home.galaxy_securities": "银河证券",
  "pc.home.gf_securities": "广发证券",
  "pc.home.go_to_you": "归您",
  "pc.home.haitong_securities": "海通证券",
  "pc.home.huatai_securities": "华泰证券",
  "pc.home.independent_account": "独立成户",
  "pc.home.interest_free_capital": "免息配资",
  "pc.home.interest_rates_low": "利率低至",
  "pc.home.live_trading_professional_certified_brand": "券商实盘 专业安全 认证品牌",
  "pc.home.login_now": "立即登录",
  "pc.home.maximum_margin": "最高保证金",
  "pc.home.million_dollar": "万美元",
  "pc.home.minimum_allocation_amount": "起配金额",
  "pc.home.month_capital": "按月配资",
  "pc.home.more": "更多",
  "pc.home.news": "新闻动态",
  "pc.home.no_interest_charged": "不收取利息",
  "pc.home.online_customer_service": "在线客服",
  "pc.home.partners": "合作伙伴",
  "pc.home.phone": "电话",
  "pc.home.ping_an_securities": "平安证券",
  "pc.home.professional_service": "专业服务",
  "pc.home.professional_service_desc": "客户体验至上为宗旨",
  "pc.home.profit": "盈利",
  "pc.home.qq_customer_service": "QQ客服",
  "pc.home.quick_withdrawals": "快捷提现",
  "pc.home.quick_withdrawals_desc": "闪电提现,最快三分钟到账",
  "pc.home.real_capital_profit": "配资5万实盘资金盈利0.8万",
  "pc.home.real_money_and_profit": "配资6万实盘资金盈利1.62万",
  "pc.home.real_trading": "真实交易",
  "pc.home.real_trading_desc": "100%实盘,同步股市数据",
  "pc.home.recently_registered_successfully": "近期已注册成功",
  "pc.home.recharge": "充值",
  "pc.home.register_as_member": "注册会员",
  "pc.home.register_now": "立即注册",
  "pc.home.registration_bonus": "注册送",
  "pc.home.return": "返回",
  "pc.home.revene_share": "收益分成",
  "pc.home.stable_and_efficient": "稳定高效",
  "pc.home.successfully_registered_today": "今日已注册成功",
  "pc.home.ten_thousands": "1万",
  "pc.home.today_recharge": "今日充值",
  "pc.home.trading_master": "操盘达人",
  "pc.home.vip_capital": "VIP配资",
  "pc.home.want_to_allocate_funds": "我要配资",
  "pc.home.week_capital": "按周配资",
  "pc.home.yuan": "元",
  "pc.information.already_set": "已设置",
  "pc.information.bank_card_binding": "银行卡绑定",
  "pc.information.bound": "绑定",
  "pc.information.certification": "认证",
  "pc.information.change_nick_name": "修改昵称",
  "pc.information.edit": "修改",
  "pc.information.enter_real_name": "请输入真实姓名",
  "pc.information.link_email": "绑定邮箱",
  "pc.information.link_mobile_number": "绑定手机号码",
  "pc.information.login_password": "登录密码",
  "pc.information.mobile_format_error": "手机号码格式不正确",
  "pc.information.mobile_phone_binding": "手机绑定",
  "pc.information.nick_name": "昵称",
  "pc.information.not_certified": "未认证",
  "pc.information.not_set": "未设置",
  "pc.information.please_enter_bank_address": "请输入开户行地址",
  "pc.information.please_enter_confirm_pw": "请输入确认密码",
  "pc.information.please_enter_new_pw": "请输入新密码",
  "pc.information.please_enter_verification_code": "请输入验证码",
  "pc.information.please_enter_your_account_holder_name": "请输入开户人姓名",
  "pc.information.please_enter_your_bank_card_number": "请输入银行卡号",
  "pc.information.please_enter_your_email": "请输入邮箱",
  "pc.information.please_enter_your_id": "请输入身份证号",
  "pc.information.please_enter_your_mobile_number": "请输入手机号码",
  "pc.information.please_enter_your_nickname": "请输入昵称",
  "pc.information.please_enter_your_password": "请输入密码",
  "pc.information.pw_not_matched": "两次密码输入不一致",
  "pc.information.security_settings": "安全设置",
  "pc.information.set_up": "设置",
  "pc.information.unbound": "未绑定",
  "pc.information.withdrawal_password": "提款密码",
  "pc.login.do_not_have_an_account": "没有账户",
  "pc.login.enter_your_image_verification_code": "请输入图形验证码",
  "pc.login.enter_your_password": "请输入登录密码",
  "pc.login.enter_your_phone_number": "请输入手机号",
  "pc.login.forgot_your_password": "忘记密码",
  "pc.login.image_code_wrong": "图片验证码不正确",
  "pc.login.register_now": "马上注册",
  "pc.login.user_login": "用户登录",
  "pc.myaccount.account_balance": "账户余额",
  "pc.myaccount.administrative_fees": "管理费用",
  "pc.myaccount.agency_account": "代理账户",
  "pc.myaccount.agent_commission": "代理佣金",
  "pc.myaccount.amount_rmb": "金额(人民币)",
  "pc.myaccount.annualized_rate_return": "年化收益率",
  "pc.myaccount.available_balance": "可转余额",
  "pc.myaccount.available_funds": "可用资金",
  "pc.myaccount.bill": "账单",
  "pc.myaccount.cancel": "取消",
  "pc.myaccount.cash_back": "赠返现金",
  "pc.myaccount.complete_information": "完善资料",
  "pc.myaccount.confirm": "确定",
  "pc.myaccount.cumulative_return": "累计收益",
  "pc.myaccount.current_assets": "当前资产",
  "pc.myaccount.deposit_now": "立即充值",
  "pc.myaccount.details": "明细",
  "pc.myaccount.disable_and_not_remind_this_week": "关闭并本周不提醒",
  "pc.myaccount.earn_money_with_stock_trading_annualized_return": "炒股理财时时赚钱 年化收益",
  "pc.myaccount.end_date": "结束日期",
  "pc.myaccount.financing_account": "配资账户",
  "pc.myaccount.first_deposit_gift_list": "首充礼品清单",
  "pc.myaccount.friend_cash_coupons": "好友现金券",
  "pc.myaccount.full_details": "全部明细",
  "pc.myaccount.fund_operations": "资金操作",
  "pc.myaccount.funding_details": "资金明细",
  "pc.myaccount.funds": "资金",
  "pc.myaccount.go_to_friend_cash_coupons": "前往好友现金券",
  "pc.myaccount.hello_danniu_securities_member": "您好,金牛证券会员",
  "pc.myaccount.holiday_treasure": "节日宝",
  "pc.myaccount.last_login_time": "上次登陆时间",
  "pc.myaccount.loan_details": "借款明细",
  "pc.myaccount.margin_trading_now": "立即配资交易",
  "pc.myaccount.my_cash_coupons": "我的现金券",
  "pc.myaccount.new_member_trading_bonus_list": "新会员交易红包清单",
  "pc.myaccount.next_page": "下一页",
  "pc.myaccount.past_8hour_return": "上8小时收益",
  "pc.myaccount.please_enter_your_id": "请输入身份证号",
  "pc.myaccount.please_enter_your_real_name": "请输入真实姓名",
  "pc.myaccount.please_verify_your_account_to_activate": "请实名激活",
  "pc.myaccount.previous_page": "上一页",
  "pc.myaccount.real_name_verification": "实名认证",
  "pc.myaccount.regular_treasure": "定期宝",
  "pc.myaccount.risk_control_notification": "风控通知",
  "pc.myaccount.search": "检索",
  "pc.myaccount.shishi_bao": "时时宝",
  "pc.myaccount.sign_in": "签到",
  "pc.myaccount.start_date": "开始日期",
  "pc.myaccount.to": "至",
  "pc.myaccount.total_assets": "资产总计",
  "pc.myaccount.total_frozen_margin": "总冻结保证金",
  "pc.myaccount.trading_inquiry": "交易查询",
  "pc.myaccount.transfer_from_shishibao": "从时时宝转出",
  "pc.myaccount.transfer_in": "转入",
  "pc.myaccount.transfer_in_amount": "转入金额",
  "pc.myaccount.transfer_out": "转出",
  "pc.myaccount.transfer_out_amount": "转出金额",
  "pc.myaccount.transfer_to_shishibao": "转入时时宝",
  "pc.myaccount.usd_gift": "美元礼金",
  "pc.myaccount.user_name": "用户名",
  "pc.myaccount.verify_your_account_now": "立即实名",
  "pc.myaccount.version_number": "版本号",
  "pc.myaccount.you_have_not_not_verify_account": "您还没有实名",
  "pc.operate.actual_payment": "实付款",
  "pc.operate.already_understand": "我已经明白",
  "pc.operate.automatic_extension": "自动延期",
  "pc.operate.automatic_renewal": "自动续期",
  "pc.operate.automatically_renews_from": "2日起,自动续期",
  "pc.operate.available_balance": "可用余额",
  "pc.operate.close_line": "平仓线",
  "pc.operate.daily_interest_rate": "日利率",
  "pc.operate.day": "日",
  "pc.operate.effective_immediately": "立即生效",
  "pc.operate.funding_amount": "配资金额",
  "pc.operate.in_total": "共",
  "pc.operate.insufficient_funds": "余额不足",
  "pc.operate.interest_free_explanation": "免息说明",
  "pc.operate.investment_capital": "投资本金",
  "pc.operate.loss_close_line": "亏损平仓线",
  "pc.operate.loss_close_line_desc": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足",
  "pc.operate.loss_waring_line": "亏损预警线",
  "pc.operate.loss_warning_line_desc": "当总配资资金低于预警线以下时，只能平仓不能建仓",
  "pc.operate.mangement_fee": "管理费",
  "pc.operate.margin": "保证金",
  "pc.operate.margin_funding": "配资资金",
  "pc.operate.margin_information": "配资信息",
  "pc.operate.margin_trading_agreement": "《配资合作协议》",
  "pc.operate.month": "月",
  "pc.operate.monthly_interest_rate": "月利率",
  "pc.operate.pay_principal": "支付本金",
  "pc.operate.payment_still_due": "本次支付还差",
  "pc.operate.read_and_agree": "我已阅读并同意",
  "pc.operate.recharge_now": "马上充值",
  "pc.operate.return_to_edit": "返回修改",
  "pc.operate.thirty_days": "30天",
  "pc.operate.times": "倍",
  "pc.operate.total_margin_amount": "总配资金额",
  "pc.operate.total_trading_capital": "总操盘资金",
  "pc.operate.trading_period": "操盘周期",
  "pc.operate.trading_start_time": "开始交易时间",
  "pc.operate.voucher": "代金券",
  "pc.operate.warning_line": "预警线",
  "pc.operate.week": "周",
  "pc.operate.weekly_interest_rate": "周利率",
  "pc.operate.your_account_balance_only": "您的账户余额只剩",
  "pc.protocol.friend_cash_voucher_term_conditions": "好友现金券使用须知",
  "pc.protocol.return_to_previous_page": "返回上一页",
  "pc.putforward.please_enter_bank_card": "请输入银行卡号",
  "pc.putforward.please_enter_withdraw_amount": "请输入提款金额",
  "pc.putforward.please_enter_withdrawal_pw": "请输入提款密码",
  "pc.putforward.please_veryfy_real_name": "请先实名认证",
  "pc.putforwardmodule.please_enter_bank_card": "请输入银行卡号",
  "pc.putforwardmodule.please_enter_withdraw_amount": "请输入提款金额",
  "pc.putforwardmodule.please_enter_withdrawal_pw": "请输入提款密码",
  "pc.putforwardmodule.please_veryfy_real_name": "请先实名认证",
  "pc.quickpay.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.recharge.please_enter_bank_card": "请输入银行卡号",
  "pc.recharge.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.recharge.please_select_bank_card": "请选择银行卡类型",
  "pc.recharge_log.status1": "等待审核",
  "pc.recharge_log.status2": "充值成功",
  "pc.recharge_log.status3": "充值失败",
  "pc.rechargeau.enter_id_number": "请输入身份证号",
  "pc.rechargeau.enter_real_name": "请输入真实姓名",
  "pc.rechargenetpay.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.rechargenetpay2.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.rechargewx.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.register.agree_to_the_registration agreement": "请同意注册协议",
  "pc.register.create_now": "立即创建",
  "pc.register.enter_referral_code": "请输入推荐码(选填)",
  "pc.register.enter_sms_verification_code": "请输入短信验证码",
  "pc.register.enter_your_password": "请输入登录密码",
  "pc.register.first_deposit": "首充",
  "pc.register.free_for_new_user_registration": "新用户注册送",
  "pc.register.gift": "豪礼",
  "pc.register.i_agree": "我同意",
  "pc.register.login_to_claim": "请登录领取",
  "pc.register.new_user_registration": "新用户注册",
  "pc.register.registration_agreement": "《注册协议》",
  "pc.register.risk_disclosure_statement": "《风险揭示书》",
  "pc.register.you_have_successfully_registered": "您已注册成功",
  "pc.stockdetaild.pls_login": "您还未登录,请前去登录",
  "pc.stocktrading.buy1": "买1",
  "pc.stocktrading.sell1": "卖1",
  "pc.strategyHistoryDetails.buy_sell_direction": "买卖方向",
  "pc.strategyHistoryDetails.click_to_view_fund_details": "点击查看资金明细",
  "pc.strategyHistoryDetails.contract_details": "合约明细",
  "pc.strategyHistoryDetails.deduction": "扣减",
  "pc.strategyHistoryDetails.end_time": "结束时间",
  "pc.strategyHistoryDetails.freeze": "冻结",
  "pc.strategyHistoryDetails.history_transactions": "历史交易",
  "pc.strategyHistoryDetails.loss_compensation": "亏损赔付",
  "pc.strategyHistoryDetails.number": "策略单号",
  "pc.strategyHistoryDetails.number_of_shares": "成交股数",
  "pc.strategyHistoryDetails.performance_bond_settlement": "履约金结算",
  "pc.strategyHistoryDetails.profit_distribution": "盈利分配",
  "pc.strategyHistoryDetails.settled": "已结算",
  "pc.strategyHistoryDetails.start_time": "开始时间",
  "pc.strategyHistoryDetails.stock_name": "股票名称",
  "pc.strategyHistoryDetails.strategy_capital": "策略资金",
  "pc.strategyHistoryDetails.total_strategic_funds": "总策略资金",
  "pc.strategyHistoryDetails.trading_profit_loss": "交易盈亏",
  "pc.strategyHistoryDetails.trading_proft_distribution": "交易盈利分配",
  "pc.strategyHistoryDetails.trading_type": "交易品种",
  "pc.strategyHistoryDetails.trans_status": "成交状态",
  "pc.strategyHistoryDetails.unfreeze": "解冻",
  "pc.strategynow.account": "账号",
  "pc.strategynow.account_management_fee": "账户管理费",
  "pc.strategynow.add_margin": "追加保证金",
  "pc.strategynow.add_strategy": "追加策略",
  "pc.strategynow.alert_triggered": "触发警戒",
  "pc.strategynow.all": "全部",
  "pc.strategynow.applied_limit": "申请额度",
  "pc.strategynow.apply_for_new_margin_account": "申请新配资账号",
  "pc.strategynow.apply_for_settlement": "申请结算",
  "pc.strategynow.buy_coins": "买币",
  "pc.strategynow.completed": "已完成",
  "pc.strategynow.confirm_current_settlement_strategy": "确认结算当前策略",
  "pc.strategynow.cost": "成本",
  "pc.strategynow.current_profit": "当前盈利",
  "pc.strategynow.current_profit_loss": "当前盈亏(美元)",
  "pc.strategynow.current_total_account_balance": "当前总账户余额",
  "pc.strategynow.daily": "按天",
  "pc.strategynow.financing": "配资中",
  "pc.strategynow.frozen_funds": "冻结资金",
  "pc.strategynow.interest_free": "免息",
  "pc.strategynow.loss_warning_line": "亏损警戒线",
  "pc.strategynow.market_value_of_positions": "持仓市值",
  "pc.strategynow.maximum_profit": "最高可提利润",
  "pc.strategynow.monthly": "按月",
  "pc.strategynow.my_orders": "我的订单",
  "pc.strategynow.please_enter_additional_amount": "请输入追加金额",
  "pc.strategynow.please_enter_withdrawal_amount": "请输入提取金额",
  "pc.strategynow.position_ratio": "持仓比例",
  "pc.strategynow.profit_and_loss": "盈亏",
  "pc.strategynow.profit_distribution": "利益分配",
  "pc.strategynow.profit_loss": "盈亏额",
  "pc.strategynow.profit_loss_margin": "盈亏幅",
  "pc.strategynow.profit_withdrawal": "利润提取",
  "pc.strategynow.risk_margin": "风险保证金",
  "pc.strategynow.sell_coins": "卖币",
  "pc.strategynow.settlement_confirmation": "结算确认",
  "pc.strategynow.stop_loss_triggered": "触发止损",
  "pc.strategynow.strategy_account_balance": "策略账户余额",
  "pc.strategynow.total_account_balance_after_additional_amount": "追加后总账户余额",
  "pc.strategynow.total_contract_equity": "合约总资产(美元)",
  "pc.strategynow.total_margin_funds": "总配资资金",
  "pc.strategynow.weekly": "按周",
  "pc.sweep.please_enter_recharge_amount": "请输入充值人民币金额",
  "pc.sweep.please_select_bank": "请选择银行",
  "pc.trading.add_to_favourite": "加入自选",
  "pc.trading.amount": "金额 ",
  "pc.trading.amplitude": "振 幅",
  "pc.trading.available": "可用",
  "pc.trading.available_for_purchase": "可开",
  "pc.trading.available_for_sale": "可开",
  "pc.trading.average_price": "均价",
  "pc.trading.balance": "余额 ",
  "pc.trading.billion": "亿元",
  "pc.trading.broker_commission": "券商佣金",
  "pc.trading.business": "业务",
  "pc.trading.business_name": "业务名称",
  "pc.trading.buy": "开仓",
  "pc.trading.buy_and_sell": "买卖",
  "pc.trading.buy_price": "价格",
  "pc.trading.buy_volume": "数量",
  "pc.trading.cancel_favourite": "取消自选",
  "pc.trading.cancel_order": "撤单",
  "pc.trading.circulating_value": "流通值",
  "pc.trading.close_short_position": "平仓",
  "pc.trading.current_price": "现价",
  "pc.trading.date": "日期",
  "pc.trading.date_time": "日期时间",
  "pc.trading.entrusted_query": "委托查询",
  "pc.trading.entrustment": "委托",
  "pc.trading.entrustment_price": "委托价",
  "pc.trading.frc_transaction": "财汇局交易征费 ",
  "pc.trading.full_position": "全仓",
  "pc.trading.highest": "最 高",
  "pc.trading.limit_price": "限价",
  "pc.trading.lowest": "最 低",
  "pc.trading.lump_sum": "总金额 ",
  "pc.trading.market": "行情",
  "pc.trading.market_buy": "市价",
  "pc.trading.market_price": "市价",
  "pc.trading.market_sell": "市价",
  "pc.trading.market_value": "市值",
  "pc.trading.operate": "操作",
  "pc.trading.platform_fees": "平台费用",
  "pc.trading.please_select_an_account": "请选择账户",
  "pc.trading.position": "持仓",
  "pc.trading.product_handling_fee": "产品处理费",
  "pc.trading.quantity": "数量",
  "pc.trading.query": "查询",
  "pc.trading.sell": "平仓",
  "pc.trading.sell_price": "价格",
  "pc.trading.sell_volume": "数量",
  "pc.trading.settlement_costs": "结算费用",
  "pc.trading.shares": "股",
  "pc.trading.short_sell": "开仓",
  "pc.trading.stamp_duty": "印花税",
  "pc.trading.statement": "对账单 ",
  "pc.trading.status": "状态",
  "pc.trading.stock": "股票",
  "pc.trading.stock_code": "股票代码",
  "pc.trading.system_closing_possition": "系统平仓",
  "pc.trading.thousands_of_hands": "万手",
  "pc.trading.time": "时间",
  "pc.trading.today_open": "今 开",
  "pc.trading.total_market_capitalization": "总市值",
  "pc.trading.total_price": "总价",
  "pc.trading.total_profit_and_loss": "总盈亏",
  "pc.trading.trading_amount": "成交额",
  "pc.trading.trading_volume": "成交量",
  "pc.trading.transaction": "成交",
  "pc.trading.transaction_amount": "成交金额",
  "pc.trading.transaction_price": "成交价",
  "pc.trading.transaction_quantity": "成交数量",
  "pc.trading.transaction_sold_price": "成交价格",
  "pc.trading.transactional_records": "成交记录",
  "pc.trading.transfer_fee": "过户费",
  "pc.trading.turnover_rate": "换手率",
  "pc.trading.type": "类型",
  "pc.trading.unit_price": "单价",
  "pc.trading.yesterday_close": "昨 收",
  "pc.tradingquery.available_sell_quantity": "可用数量",
  "pc.tradingquery.buy_amount": "开仓交易额",
  "pc.tradingquery.cancellation_order_query": "撤单查询",
  "pc.tradingquery.commission": "佣金",
  "pc.tradingquery.cost_price": "成本价",
  "pc.tradingquery.current_price": "当前价",
  "pc.tradingquery.frozen_quantity": "冻结数量",
  "pc.tradingquery.opening_date": "开仓日",
  "pc.tradingquery.order_date": "委托日期",
  "pc.tradingquery.order_direction": "委托方向",
  "pc.tradingquery.order_price": "委托价格",
  "pc.tradingquery.order_quantity": "委托数量",
  "pc.tradingquery.order_status": "委托状态",
  "pc.tradingquery.order_time": "委托时间",
  "pc.tradingquery.platform_fee": "平台费",
  "pc.tradingquery.position_query": "持仓查询",
  "pc.tradingquery.profit_loss_amount": "盈亏金额",
  "pc.tradingquery.profit_loss_ratio": "盈亏比例",
  "pc.tradingquery.sell_amount": "卖出额",
  "pc.tradingquery.settlement_and_settlement_fee": "结算交收费",
  "pc.tradingquery.total_position": "总持仓数",
  "pc.tradingquery.transaction_direction": "交易方向",
  "pc.tradingquery.transaction_fee": "交易费",
  "pc.tradingquery.transaction_inquiry": "成交查询",
  "pc.tradingquery.transaction_levy": "交易征费",
  "pc.tradingquery.transaction_time": "成交时间",
  "pc.tradingquery.unfilled_quantity": "未成交数量",
  "pc.usercoupon.after_margin_financing_purchase_amount_reaches": "配资后买入额达到",
  "pc.usercoupon.cash_coupon": "现金券",
  "pc.usercoupon.get_rmb": "元送",
  "pc.usercoupon.no_records_yet": "暂无记录",
  "pc.usercoupon.requirements": "要求",
  "pc.usercoupon.withdrawal_is_available_after_rmb": "元后可提现",
  "system.ActivityInfo.account_insufficient_funds": "你的账户资金不足",
  "system.ActivityInfo.already_experienced_free_funding": "你已经体验过免费配资了",
  "system.ActivityInfo.free_funding_application_failed": "免息配资申请失败",
  "system.ActivityInfo.free_funding_application_success": "免息配资申请成功",
  "system.AgentCreate.agent_already_opened": "代理已经开通",
  "system.AgentCreate.agent_opened_failed": "代理开通失败",
  "system.AgentCreate.agent_opened_success": "代理开通成功",
  "system.AgentInfo.account_balance_insufficient": "您的账户余额不足",
  "system.AgentInfo.amount_input_error": "您输入的金额有误",
  "system.AgentInfo.fund_transfer_failed": "资金划转失败",
  "system.AgentInfo.fund_transfer_success": "资金划转成功",
  "system.AgentInfo.no_promotion_code_contact_service": "没有推广码,请联系客服",
  "system.AgentInfo.transfer_amount_input_error": "您输入的划转金额有误",
  "system.AgentInfo.withdrawal_application_failed": "提现申请失败",
  "system.AgentInfo.withdrawal_application_success": "提现申请成功",
  "system.AutoClose.margin_call_fail": "追加保证金失败",
  "system.AutoClose.margin_call_sucesss": "追加保证金成功",
  "system.AutoClose.order_sell_fail": "委托出售失败",
  "system.AutoClose.order_sell_suceess": "委托出售成功",
  "system.AutoDepot.purchase_failed": "购买失败",
  "system.AutoDepot.purchase_success": "购买成功",
  "system.AutoDepot.sell_stock_failed": "出售股票失败",
  "system.AutoDepot.sell_stock_success": "出售股票成功",
  "system.Banks.account_holder_name_cannot_be_empty": "开户姓名不能为空",
  "system.Banks.account_holder_name_inconsistent_with_verification": "开户姓名与认证姓名不一致",
  "system.Banks.bank_branch_cannot_be_empty": "开户支行不能为空",
  "system.Banks.bank_card_number_cannot_be_empty": "银行卡号不能为空",
  "system.Banks.bank_card_number_format_error": "银行卡号格式错误",
  "system.Banks.bank_name_cannot_be_empty": "银行名称不能为空",
  "system.Banks.bank_not_open": "此银行暂未开放",
  "system.Banks.bind_failed": "绑定失败",
  "system.Banks.bind_success": "绑定成功",
  "system.Banks.first_real_name_verification_to_bind_bank_card": "首先实名认证才能绑定银行卡",
  "system.Banks.modify_failed": "修改失败",
  "system.Banks.modify_success": "修改成功",
  "system.CancelEntrust.batch_cancel_entrust_failed": "一键撤销委托失败",
  "system.CancelEntrust.batch_cancel_entrust_success": "一键撤销委托成功",
  "system.CancelEntrust.cancel_entrust_order_failed": "撤销委托订单失败",
  "system.CancelEntrust.cancel_entrust_order_not_exists": "撤销委托订单不存在",
  "system.CancelEntrust.cancel_entrust_order_success": "撤销委托订单成功",
  "system.CancelEntrust.cancel_order_success": "撤销委托订单成功",
  "system.CancelEntrust.entrust_order_id_not_exists": "委托订单标示不存在",
  "system.CancelEntrust.funding_info_not_exists": "配资信息不存在",
  "system.CancelEntrust.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.CancelEntrust.no_entrust_info": "没有委托信息",
  "system.CancelEntrust.position_info_not_exists": "持仓信息不存在",
  "system.CapitalHistory.funding_unique_id_not_passed": "没有传递配资唯一标示",
  "system.CapitalOperate.account_balance_insufficient": "你的账户余额不足",
  "system.CapitalOperate.account_balance_insufficient_exclamation": "你的账户余额不足！",
  "system.CapitalOperate.account_insufficient_funds": "你的账户资金不足",
  "system.CapitalOperate.additional_amount_format_error": "追加金额格式错误",
  "system.CapitalOperate.additional_amount_must_not_less_than_0": "追加金额不能小于0",
  "system.CapitalOperate.additional_funding_amount_must_be_100_multiple": "追加配资金额必须为100的倍数",
  "system.CapitalOperate.additional_funding_amount_must_not_less_than_0": "追加配金额不能必须小于0",
  "system.CapitalOperate.additional_funding_failed": "追加配资失败",
  "system.CapitalOperate.additional_funding_success": "追加配资成功",
  "system.CapitalOperate.additional_margin_failed": "追加保证金失败",
  "system.CapitalOperate.additional_margin_success": "追加保证金成功",
  "system.CapitalOperate.free_funding_cannot_withdraw_profit": "免息配资不能做利润提现！",
  "system.CapitalOperate.minimum_additional_amount": "最低追加资本额达到",
  "system.CapitalOperate.minimum_additional_funding_amount": "最低追加资本额达到",
  "system.CapitalOperate.please_enter_additional_amount": "请输入追加金额",
  "system.CapitalOperate.please_enter_additional_funding_amount": "请输入追加配资金额",
  "system.CapitalOperate.please_enter_withdrawal_amount": "请输入提取金额",
  "system.CapitalOperate.please_select_funding_order": "请选择配资订单",
  "system.CapitalOperate.profit_amount_insufficient": "盈利金额不足",
  "system.CapitalOperate.sorry_function_not_yet_open": "对不起，本功能还未开放！",
  "system.CapitalOperate.withdraw_profit_failed": "提取利润失败",
  "system.CapitalOperate.withdraw_profit_success": "提取利润成功",
  "system.CapitalOperate.withdrawal_amount_format_error": "提取金额格式错误",
  "system.CapitalOperate.withdrawal_amount_must_greater_than_0": "提取金额不能必须大于0",
  "system.CapitalWith.account_insufficient_funds": "你的账户资金不足",
  "system.CapitalWith.funding_application_failed": "配资申请失败",
  "system.CapitalWith.funding_application_success": "配资申请成功",
  "system.CapitalWith.funding_multiple_selection_error": "配资倍数选择错误",
  "system.CapitalWith.margin_must_be_100_multiple": "保证金为100的倍数",
  "system.CapitalWith.maximum_risk_margin": "较高风险保证金",
  "system.CapitalWith.minimum_risk_margin": "较低风险保证金",
  "system.CapitalWith.not_yet_open": "暂未开放",
  "system.CapitalWith.please_enter_risk_margin": "请输入风险保证金",
  "system.CapitalWith.please_select_funding_multiple": "请选择配资倍数",
  "system.CapitalWith.please_select_operation_type": "请选择操作类型",
  "system.Capital_model.funding_info_not_exists": "配资信息不存在",
  "system.Capital_model.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.Concern.add_to_watchlist_failed": "加入自选股失败",
  "system.Concern.add_to_watchlist_success": "加入自选股成功",
  "system.Concern.code_cannot_be_empty": "代码不能为空",
  "system.Concern.code_not_exists": "代码不存在",
  "system.Concern.remove_from_watchlist_failed": "删除自选失败",
  "system.Concern.remove_from_watchlist_success": "删除自选成功",
  "system.Concern.remove_from_watchlist_success_simple": "删除自选成功",
  "system.Concern.stock_not_yet_open": "暂未开放此股票",
  "system.ExactLog.profit_withdrawal": "利润提取",
  "system.Finance.account_insufficient_funds": "你的资金余额不足",
  "system.Finance.delete_operation_failed": "删除操作失败",
  "system.Finance.deleted": "已删除",
  "system.Finance.disagree_transaction_channel": "不同意交易渠道",
  "system.Finance.minimum_withdrawal_amount": "需要申请大于最低提款金额",
  "system.Finance.please_bind_bank_card": "请绑定银行卡",
  "system.Finance.please_enter_application_amount": "请输入申请金额",
  "system.Finance.please_enter_gxpay_id": "请输入您的GXPay ID",
  "system.Finance.please_enter_recharge_amount": "请输入充值资金",
  "system.Finance.please_enter_withdrawal_password": "请输入提现密码",
  "system.Finance.please_select_recharge_type": "请选择充值类型",
  "system.Finance.recharge_amount_must_be_100_multiple": "充值金额必须为100的倍数",
  "system.Finance.recharge_amount_must_be_integer": "充值金额必须为整数",
  "system.Finance.recharge_application_failed": "充值申请失败",
  "system.Finance.recharge_application_success": "充值申请成功",
  "system.Finance.recharge_confirmation": "充值确认",
  "system.Finance.recharge_confirmation_operation_failed": "充值确认操作失败",
  "system.Finance.recharge_type_selection_error": "充值类型选择错误",
  "system.Finance.withdrawal_amount_must_be_integer": "提现金额必须为整数",
  "system.Finance.withdrawal_application_failed": "提现申请失败",
  "system.Finance.withdrawal_application_success": "提现申请成功",
  "system.Finance.withdrawal_password_input_error": "提现密码输入错误",
  "system.Finance.withdrawal_password_not_set": "提现密码未设置",
  "system.FinanceDetail_model.is_repeat_no": "否",
  "system.FinanceDetail_model.is_repeat_yes": "是",
  "system.FinanceDetail_model.period_months_suffix": "个月",
  "system.FinanceDetail_model.period_weeks_suffix": "天",
  "system.FinanceFund.account_insufficient_balance": "账户余额不足",
  "system.FinanceFund.fund_transfer_in_failed": "资金转入失败",
  "system.FinanceFund.fund_transfer_in_success": "资金转入成功",
  "system.FinanceFund.fund_transfer_out_failed": "资金转出失败",
  "system.FinanceFund.fund_transfer_out_success": "资金转出成功",
  "system.FinanceFund.idle_money_manager_type_not_found": "没有找到闲钱管家类型",
  "system.FinanceFund.investable_balance_insufficient": "可投资余额不足",
  "system.FinanceFund.investment_fail": "投资失败",
  "system.FinanceFund.investment_sucess": "投资成功",
  "system.FinanceFund.no_settlement_document_selected": "没有选择结算单据",
  "system.FinanceFund.please_enter_amount": "请输入金额",
  "system.FinanceFund.please_enter_correct_amount": "请输入正确的金额",
  "system.FinanceFund.please_select_idle_money_manager_type": "请选择闲钱管家类型",
  "system.FinanceFund.settlement_document_not_found": "没有找到结算单据",
  "system.FinanceFund.settlement_failed": "结算失败",
  "system.FinanceFund.settlement_success": "结算成功",
  "system.FinanceFund.transferable_amount_insufficient": "可转金额不足",
  "system.FirstVoucher.already_signed_today_next_trading_day": "今天您已签到,下一个交易日再来！",
  "system.FirstVoucher.backend_bonus": "后台送",
  "system.FirstVoucher.batch_process_cash_failed": "批处理送现金失败！",
  "system.FirstVoucher.batch_process_voucher_failed": "批处理送代金券失败！",
  "system.FirstVoucher.capital_allocate": "的利息费",
  "system.FirstVoucher.deposit_bonus": "充值送",
  "system.FirstVoucher.event_bonus": "活动送",
  "system.FirstVoucher.first_deposit_bonus": "首充送",
  "system.FirstVoucher.first_recharge_batch_process_success": "首充活动批处理成功",
  "system.FirstVoucher.first_trade_bonus": "首次交易送",
  "system.FirstVoucher.real_name_bonus": "实名送",
  "system.FirstVoucher.sign_bonus": "注册送",
  "system.FirstVoucher.sign_in_bonus": "签到送",
  "system.FirstVoucher.signin_success_congratulations_voucher": "签到成功",
  "system.FirstVoucher.trial_bonus": "体验送",
  "system.FirstVoucher.voucher_bounus": "代金券使用",
  "system.FirstVoucher.welcome_signin_non_trading_day": "欢迎签到，今天是非交易日！",
  "system.FirstVoucher.winning_bonus": "中奖送",
  "system.ForgetPassword.new_password_cannot_be_empty": "新密码不能为空",
  "system.ForgetPassword.new_password_must_be_6_to_12_digits": "新密码必须为6-12位",
  "system.ForgetPassword.phone_number_format_incorrect": "手机号码格式不正确",
  "system.ForgetPassword.phone_number_incorrect": "手机号码不正确",
  "system.ForgetPassword.phone_number_not_registered": "此手机号码未注册",
  "system.ForgetPassword.phone_verification_code_incorrect": "手机验证码不正确",
  "system.ForgetPassword.please_enter_phone_verification_code": "请输入手机验证码",
  "system.ForgetPassword.please_enter_registration_phone_number": "请输入注册手机号码",
  "system.ForgetPassword.retrieve_login_password_failed": "找回登录密码失败",
  "system.ForgetPassword.retrieve_login_password_success": "找回登录密码成功",
  "system.ForgetPassword.two_password_inputs_inconsistent": "两次输入密码不一致",
  "system.FriendCoupon.friend_voucher_generation_complete": "好友代金券生成完毕",
  "system.HolidayFund.account_insufficient_balance": "账户余额不足",
  "system.HolidayFund.auto_transfer_modify_success": "自动转入修改成功",
  "system.HolidayFund.fund_transfer_failed": "资金转出失败",
  "system.HolidayFund.fund_transfer_in_failed": "资金转入失败",
  "system.HolidayFund.fund_transfer_in_success": "资金转入成功",
  "system.HolidayFund.fund_transfer_successful": "资金转出成功",
  "system.HolidayFund.holiday_account_not_found": "没找到节日宝账户",
  "system.HolidayFund.insufficient_investable_balance": "可投资余额不足",
  "system.HolidayFund.insufficient_transferable_amountt": "可转金额不足",
  "system.HolidayFund.investment_failed": "投资失败",
  "system.HolidayFund.investment_successful": "投资成功",
  "system.HolidayFund.no_settlement_document_found": "没有找到结算单据",
  "system.HolidayFund.no_settlement_document_selected": "没有选择结算单据",
  "system.HolidayFund.please_enter_amount": "请输入金额",
  "system.HolidayFund.please_enter_correct_amount": "请输入正确的金额",
  "system.HolidayFund.please_select_holiday_product": "请选择节日宝产品",
  "system.HolidayFund.product_not_found": "没有找到节日宝产品",
  "system.HolidayFund.settlement_failed": "结算失败",
  "system.HolidayFund.settlement_successf": "结算成功",
  "system.HolidayType_model.period_days_suffix": "天",
  "system.Home.no_activity": "没有活动！",
  "system.Home1.no_activity": "没有活动！",
  "system.KLine.illegal_input": "非法输入",
  "system.KLine.kline_type_not_specified": "没有指定K线类型！",
  "system.KLine.stock_code_not_specified": "没有指定股票代码！",
  "system.LoanLog.apply_finance": "追加配资",
  "system.LoanLog.apply_margin": "申请配资",
  "system.Login.information_error": "信息错误!",
  "system.Login.login_failed": "登录失败",
  "system.Login.login_success": "登录成功",
  "system.Login.no_permission": "你没有权限",
  "system.Login.phone_encryption_end": "电话加密结束",
  "system.Login.phone_or_password_error": "手机号码或登录密码错误",
  "system.Login.please_enter_login_password": "请输入登录密码",
  "system.Login.please_enter_phone_number": "请输入手机号码",
  "system.ManageLog.management_fee": "管理费",
  "system.Member.agent_opened_failed": "代理开通失败",
  "system.Member.agent_opened_success": "代理开通成功",
  "system.Member.already_real_name_verified": "已经实名认证",
  "system.Member.confirm_password_cannot_be_empty": "确认新密码不能为空",
  "system.Member.contact_service_complete_real_name_verification": "请联系客服完成实名认证后，再操作忘记密码。",
  "system.Member.email_format_error": "邮箱信格式错误",
  "system.Member.email_verification_code_error": "邮箱验证码错误",
  "system.Member.id_number_format_error": "身份证号格式错误",
  "system.Member.modify_failed": "修改失败",
  "system.Member.modify_phone_failed": "修改手机号码失败",
  "system.Member.modify_phone_success": "修改手机号码成功",
  "system.Member.modify_success": "修改成功",
  "system.Member.new_password_must_be_6_to_12_digits": "新密码必须6-12位",
  "system.Member.nickname_modify_failed": "昵称修改失败",
  "system.Member.nickname_modify_success": "昵称修改成功",
  "system.Member.operation_failed": "操作失败",
  "system.Member.operation_success": "操作成功",
  "system.Member.phone_number_format_error": "手机号码格式错误",
  "system.Member.phone_verification_code_error": "手机验证码错误",
  "system.Member.please_contact_service": "请联系客服",
  "system.Member.please_enter_email": "请输入邮箱信息",
  "system.Member.please_enter_email_verification_code": "请输入邮箱验证码",
  "system.Member.please_enter_id_number": "请输入身份证号",
  "system.Member.please_enter_new_password": "请输入新密码",
  "system.Member.please_enter_nickname": "请输入昵称",
  "system.Member.please_enter_phone_number": "请输入手机号码",
  "system.Member.please_enter_phone_verification_code": "请输入手机验证码",
  "system.Member.please_enter_real_name": "请输入真实名称",
  "system.Member.real_name_format_error": "真实名称格式错误",
  "system.Member.real_name_verification_application_failed": "申请实名认证失败",
  "system.Member.real_name_verification_application_success": "申请实名认证成功",
  "system.Member.two_password_inputs_inconsistent": "两次输入新密码不一致",
  "system.Member.user_already_used": "该用户已经被使用",
  "system.Member.verification": "验证",
  "system.NewsCenter.news_not_found": "查询新闻不存在",
  "system.NewsCenter.please_pass_news_unique_id": "请传递新闻唯一标示",
  "system.Notice_model.date_format": "Y年m月d日",
  "system.Nozzle.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.Nozzle.data_normal": "数据正规",
  "system.Nozzle.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.Offline.disagree_transaction_channel": "不同意交易渠道",
  "system.Offline.fast_channel_temporarily_closed_contact_service": "快速通道暂时关闭,请联系在线客服",
  "system.Offline.order_failed_large_amount_contact_service": "下单失败，大额入款请联系在线客服",
  "system.Offline.please_contact_online_service": "请联系在线客服",
  "system.Offline.please_do_not_frequent_operation_wait_3min": "请勿频繁操作,请等待3分钟后重新尝试",
  "system.Offline.please_enter_recharge_amount": "请输入充值资金",
  "system.Offline.please_go_real_name_verification": "请前去实名认证",
  "system.Offline.please_select_fixed_amount": "请选择固定金额",
  "system.Offline.please_select_recharge_type": "请选择充值类型",
  "system.Offline.recharge_amount_must_be_100_multiple": "充值金额必须为100的倍数",
  "system.Offline.recharge_amount_must_be_integer": "充值金额必须为整数",
  "system.Offline.recharge_amount_must_be_over_100": "充值金额必须为100以上",
  "system.Offline.recharge_application_failed": "充值申请失败",
  "system.Offline.recharge_application_success_contact_service": "充值申请成功,尽快完成后续操作,联系客服吧",
  "system.Offline.recharge_type_selection_error": "充值类型选择错误",
  "system.PayBasic.recharge_application_failed": "充值申请失败",
  "system.PayBasic.recharge_application_success": "充值申请成功",
  "system.PayFive.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.PayFive.application_failed": "申请失败",
  "system.PayFive.application_success": "申请成功",
  "system.PayFive.bank_card_format_error": "银行卡号格式错误",
  "system.PayFive.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.PayFive.payment_bank_not_open": "支付银行暂未开放",
  "system.PayFive.please_enter_recharge_amount": "请输入充值资金",
  "system.PayFive.please_select_payment_bank": "请选择支付银行",
  "system.PayFive.please_select_payment_bank_card": "请选择支付银行卡号",
  "system.PayFive.quick_pay_minimum_20_yuan": "快捷支付最少充值20元",
  "system.PayOne.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.PayOne.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.PayOne.please_bind_bank_card": "请绑定银行卡",
  "system.PayOne.please_enter_recharge_amount": "请输入充值资金",
  "system.PayOne.please_real_name_verification": "请实名认证",
  "system.PayOne.recharge_application_failed": "充值申请失败",
  "system.PayOne.recharge_application_success": "充值申请成功",
  "system.PhoneCode.enter_registration_phone_number": "输入注册手机号码",
  "system.PhoneCode.name_or_id_number_error": "您输入的姓名或者身份证号码有错误",
  "system.PhoneCode.phone_number_already_registered": "手机号码已被注册",
  "system.PhoneCode.phone_number_format_incorrect": "手机号码格式不正确",
  "system.PhoneCode.phone_number_not_registered": "手机号码尚未注册",
  "system.PhoneCode.please_enter_correct_captcha": "请输入正确的图形验证码",
  "system.PhoneCode.please_try_again_later": "请稍后再尝试",
  "system.PhoneCode.send_failed": "发送失败",
  "system.PhoneCode.type_error": "类型错误",
  "system.PhoneCode.verification_code_sent_success": "你的验证码发送成功,请注意查收",
  "system.PhoneCode.verification_code_valid_5min_too_frequent": "验证码5分钟内有效,您发送过于频繁,请稍后尝试",
  "system.Protocols.please_enter_protocol_unique_id": "请输入协议唯一标示",
  "system.RealCancelEntrust.batch_cancel_entrust_failed": "一键撤销委托失败",
  "system.RealCancelEntrust.batch_cancel_entrust_success": "一键撤销委托成功",
  "system.RealCancelEntrust.cancel_entrust_order_failed": "撤销委托订单失败",
  "system.RealCancelEntrust.cancel_entrust_order_not_exists": "撤销委托订单不存在",
  "system.RealCancelEntrust.cancel_entrust_order_success": "撤销委托订单成功",
  "system.RealCancelEntrust.entrust_order_id_not_exists": "委托订单标示不存在",
  "system.RealCancelEntrust.funding_info_not_exists": "配资信息不存在",
  "system.RealCancelEntrust.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealCancelEntrust.no_entrust_info": "没有委托信息",
  "system.RealCancelEntrust.position_info_not_exists": "持仓信息不存在",
  "system.RealCapitalHistory.funding_unique_id_not_passed": "没有传递配资唯一标示",
  "system.RealCapitalOperate.account_balance_insufficient": "你的账户余额不足",
  "system.RealCapitalOperate.account_balance_insufficient_exclamation": "你的账户余额不足！",
  "system.RealCapitalOperate.additional_amount_format_error": "追加金额格式错误",
  "system.RealCapitalOperate.additional_amount_must_not_less_than_0": "追加金额不能小于0",
  "system.RealCapitalOperate.additional_funding_amount_must_be_100_multiple": "追加配资金额必须为100的倍数",
  "system.RealCapitalOperate.additional_funding_amount_must_not_less_than_0": "追加配金额不能必须小于0",
  "system.RealCapitalOperate.additional_funding_failed": "追加配资失败",
  "system.RealCapitalOperate.additional_funding_success": "追加配资成功",
  "system.RealCapitalOperate.additional_margin_failed": "追加保证金失败",
  "system.RealCapitalOperate.additional_margin_success": "追加保证金成功",
  "system.RealCapitalOperate.free_funding_cannot_withdraw_profit": "免息配资不能做利润提现！",
  "system.RealCapitalOperate.minimum_additional_amount": "最低追加金额{amount}元",
  "system.RealCapitalOperate.minimum_additional_funding_amount": "单次最低追加配资金额{amount}元",
  "system.RealCapitalOperate.please_enter_additional_amount": "请输入追加金额",
  "system.RealCapitalOperate.please_enter_additional_funding_amount": "请输入追加配资金额",
  "system.RealCapitalOperate.please_enter_withdrawal_amount": "请输入提取金额",
  "system.RealCapitalOperate.please_select_funding_order": "请选择配资订单",
  "system.RealCapitalOperate.profit_amount_insufficient": "盈利金额不足",
  "system.RealCapitalOperate.withdraw_profit_failed": "提取利润失败",
  "system.RealCapitalOperate.withdraw_profit_success": "提取利润成功",
  "system.RealCapitalOperate.withdrawal_amount_format_error": "提取金额格式错误",
  "system.RealCapitalOperate.withdrawal_amount_must_greater_than_0": "提取金额不能必须大于0",
  "system.RealCapitalWith.account_insufficient_funds": "你的账户资金不足",
  "system.RealCapitalWith.funding_application_failed": "配资申请失败",
  "system.RealCapitalWith.funding_application_success": "配资申请成功",
  "system.RealCapitalWith.funding_multiple_selection_error": "配资倍数选择错误",
  "system.RealCapitalWith.margin_must_be_100_multiple": "保证金为100的倍数",
  "system.RealCapitalWith.maximum_risk_margin": "最多风险保证金{amount}",
  "system.RealCapitalWith.minimum_risk_margin": "最少风险保证金{amount}",
  "system.RealCapitalWith.not_yet_open": "暂未开放",
  "system.RealCapitalWith.please_enter_risk_margin": "请输入风险保证金",
  "system.RealCapitalWith.please_select_funding_multiple": "请选择配资倍数",
  "system.RealCapitalWith.please_select_operation_type": "请选择操作类型",
  "system.RealCapital_model.funding_info_not_exists": "配资信息不存在",
  "system.RealCapital_model.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealDeal_model.market_price_prefix": "市价",
  "system.RealDeal_model.type_buy": "买入",
  "system.RealDeal_model.type_sell": "卖出",
  "system.RealEntrust_model.status_cancelled": "已撤销",
  "system.RealSettlement.entrust_orders_unprocessed_cannot_settle": "你有委托订单未处理，暂时无法结算",
  "system.RealSettlement.funding_settlement_failed": "配资结算失败",
  "system.RealSettlement.funding_settlement_success": "配资结算成功",
  "system.RealSettlement.position_orders_unprocessed_cannot_settle": "你有持仓订单未处理，暂时无法结算",
  "system.RealSettlement.settlement_cycle_minimum_two_days": "结算的周期最低为两天",
  "system.RealTradeBuy.buy_price_format_error": "购买价位格式错误",
  "system.RealTradeBuy.buy_quantity_cannot_be_empty": "购买数量不能为空",
  "system.RealTradeBuy.buy_quantity_format_error": "购买数量格式错误",
  "system.RealTradeBuy.buy_quantity_must_be_100_multiple": "购买数量为100的倍数",
  "system.RealTradeBuy.entrust_failed": "委托失败",
  "system.RealTradeBuy.entrust_success": "委托成功",
  "system.RealTradeBuy.funding_account_insufficient_funds": "您的配资账户资金不足",
  "system.RealTradeBuy.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealTradeBuy.please_enter_stock_code": "请输入股票代码",
  "system.RealTradeBuy.purchase_failed": "购买失败",
  "system.RealTradeBuy.selected_funding_info_not_exists": "选择配资信息不存在",
  "system.RealTradeSell.entrust_failed": "委托失败",
  "system.RealTradeSell.entrust_success": "委托成功",
  "system.RealTradeSell.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.RealTradeSell.please_enter_sell_quantity": "请输入出售数量",
  "system.RealTradeSell.please_enter_stock_code": "请输入股票代码",
  "system.RealTradeSell.position_info_not_exists": "持仓信息不存在",
  "system.RealTradeSell.selected_funding_info_not_exists": "选择配资信息不存在",
  "system.RealTradeSell.sell_price_format_error": "出售价位格式错误",
  "system.RealTradeSell.sell_quantity_format_error": "出售数量格式错误",
  "system.RealTradeSell.sell_quantity_must_greater_than_100": "出售数量必须大于100",
  "system.RealTradeSell.sell_stock_failed": "出售股票失败",
  "system.RealTradeSell.sell_stock_success": "出售股票成功",
  "system.RealTradeSell.stock_limit_down_trading_prohibited": "股票跌停板禁止交易",
  "system.RealTradeSell.stock_temporarily_unavailable": "股票暂时无法交易",
  "system.RealTradeSell.stock_today_trading_restricted": "此股票今日限制交易",
  "system.RealTradeSell.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.Recharge_model.operation_failed": "操作失败",
  "system.Recharge_model.operation_success": "操作成功",
  "system.Recharge_model.third_party_updated_confirmation": "请确认是否有第三方已经做了更新！",
  "system.RecommendShare.parameter_value_invalid": "参数值无效",
  "system.RecommendShare.please_enter_category": "请输入类别",
  "system.RecommendShare.recharge_insufficient": "充值不足",
  "system.Register.cash_voucher_already_used": "现金券已经被使用",
  "system.Register.cash_voucher_unavailable": "现金券不可用",
  "system.Register.login_password_format_error": "登录密码必须为6-12字母+数字",
  "system.Register.phone_number_already_registered": "手机号码已注册",
  "system.Register.phone_number_format_error": "手机号码格式错误",
  "system.Register.phone_number_mismatch": "手机号码和接受手机号码不符",
  "system.Register.phone_verification_code_error": "手机验证码错误",
  "system.Register.please_enter_login_password": "请输入登录密码",
  "system.Register.please_enter_phone_number": "请输入手机号码",
  "system.Register.please_enter_phone_verification_code": "请输入手机验证码",
  "system.Register.registration_failed": "注册失败",
  "system.Register.registration_success": "注册成功",
  "system.RiskControls.approching_warning_line": "元，离预警线",
  "system.RiskControls.away_from_liquidation_line": "元，离平仓线",
  "system.RiskControls.close_the_possition_balance": "进行平仓。余额",
  "system.RiskControls.close_to_the_liquidation": "离平仓线",
  "system.RiskControls.contract_balance": "合约余额",
  "system.RiskControls.current_market_capitalization": "元,当前市值",
  "system.RiskControls.dear_customer_your_account": "尊敬的客户,您的账户",
  "system.RiskControls.dear_customer_your_contract_number": "尊敬的客户,您的合约号",
  "system.RiskControls.gem_star_board_position_ratio_limit": "创业板或科创板单只股票持仓比例比不得超过100%",
  "system.RiskControls.individual_stock_position_exceeds_limit": "个人单支股票累计持仓超过限额",
  "system.RiskControls.insufficient_funds": "余额不足",
  "system.RiskControls.loan_amount": "借款额",
  "system.RiskControls.loss_exceeds_warning_line_trading_prohibited": "亏损超过预警线禁止交易",
  "system.RiskControls.margin": "元,保证金",
  "system.RiskControls.margin_call_required": "元，需要补保证金",
  "system.RiskControls.max_min_price_limit_exceeded": "最高最低买卖价格收盘价的9倍或9分之一",
  "system.RiskControls.maximum_price_trading_restricted": "最高价格限制交易",
  "system.RiskControls.member_account": "会员账户",
  "system.RiskControls.please_recharge_your_margin_to_avoid_losses": "元,请及时追加保证金以免系统自动平仓造成损失",
  "system.RiskControls.position_info_not_exists": "持仓信息不存在",
  "system.RiskControls.profit_loss": "元,盈亏",
  "system.RiskControls.right_to_close_positions_our_discretion": "元，依合同约定，我方将有权择机平仓，请及时关注",
  "system.RiskControls.stock_accumulated_over_50million_prohibited": "股票累计超过5000万,禁止交易",
  "system.RiskControls.stock_not_open_for_trading": "此股票暂未开放交易",
  "system.RiskControls.stock_temporarily_prohibited_contact_service": "此股票暂时禁止交易,请联系客服",
  "system.RiskControls.stock_today_trading_restricted": "此股票今日限制交易",
  "system.RiskControls.stock_trading_prohibited": "此股票禁止交易",
  "system.RiskControls.subject_to_contract_termination": "尊敬的客户,您的账户已欠费,将选择合约",
  "system.RiskControls.suspended_stock_trading_prohibited": "停牌股票禁止交易",
  "system.RiskControls.system_has_closed_and_settled": "已到期，系统按找约定进行平仓结算",
  "system.RiskControls.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.RiskControls.with_losses_exceeding": "元，亏损超过",
  "system.RiskControls.yuan": "元",
  "system.Settlement.entrust_orders_unprocessed_cannot_settle": "你有委托订单未处理，暂时无法结算",
  "system.Settlement.funding_settlement_failed": "配资结算失败",
  "system.Settlement.funding_settlement_success": "配资结算成功",
  "system.Settlement.position_orders_unprocessed_cannot_settle": "你有持仓订单未处理，暂时无法结算",
  "system.StockPrice.no_candlestick_type": "没有指定K线类型！",
  "system.StockPrice.no_symbol": "没有指定股票代码！",
  "system.Stocks.current_stock_market_closed_cannot_trade": "当前股票休市中无法交易",
  "system.Stocks.current_stock_trading_prohibited": "当前股票禁止交易",
  "system.Stocks.please_enter_correct_code": "请输入正确的代码",
  "system.Test.abnormal_login_please_relogin": "异常登录，请重新登录",
  "system.Test.data_normal": "数据正规",
  "system.Test.login_timeout_please_relogin": "登录超时，请重新登录",
  "system.TimebaoFund.account_insufficient_balance": "账户余额不足",
  "system.TimebaoFund.account_not_found": "没找到余额宝账户",
  "system.TimebaoFund.fund_transfer_in_failed": "资金转入失败",
  "system.TimebaoFund.fund_transfer_in_success": "资金转入成功",
  "system.TimebaoFund.fund_transfer_out_failed": "资金转出失败",
  "system.TimebaoFund.fund_transfer_out_success": "资金转出成功",
  "system.TimebaoFund.initialize_valid_principal": "初始化有效本金",
  "system.TimebaoFund.interest_calculation_failed": "利息计算失败",
  "system.TimebaoFund.interest_calculation_success": "利息计算成功",
  "system.TimebaoFund.modify_success": "修改成功",
  "system.TimebaoFund.no_balance": "没有余额",
  "system.TimebaoFund.no_interest": "没有利息",
  "system.TimebaoFund.please_enter_amount": "请输入金额",
  "system.TimebaoFund.please_enter_correct_amount": "请输入正确的金额",
  "system.TimebaoFund.transferable_amount_insufficient": "可转金额不足",
  "system.TimebaoFund.user_interest_already_calculated": "该用户利息计算已计算",
  "system.TradeBuy.account_abnormal_contact_service": "此账户异常，请联系客服",
  "system.TradeBuy.account_expired_buy_prohibited": "此账户到期，禁止买入",
  "system.TradeBuy.buy_price_error": "购买价格错误",
  "system.TradeBuy.buy_price_format_error": "购买价位格式错误",
  "system.TradeBuy.buy_quantity_cannot_be_empty": "购买数量不能为空",
  "system.TradeBuy.buy_quantity_format_error": "购买数量格式错误",
  "system.TradeBuy.entrust_failed": "委托失败",
  "system.TradeBuy.entrust_success": "委托成功",
  "system.TradeBuy.funding_account_insufficient_funds": "您的配资账户资金不足",
  "system.TradeBuy.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.TradeBuy.market_closed_cannot_trade": "休市时间,无法交易",
  "system.TradeBuy.minimum_buy_amount_limit": "最小买入额为（{amount}）港元",
  "system.TradeBuy.please_enter_stock_code": "请输入股票代码",
  "system.TradeBuy.please_enter_trade_quantity": "请输入交易数量",
  "system.TradeBuy.purchase_failed": "购买失败",
  "system.TradeBuy.purchase_success": "购买成功",
  "system.TradeBuy.stock_trading_suspended": "此股票暂停交易",
  "system.TradeSell.account_abnormal_contact_service": "此账户异常，请联系客服",
  "system.TradeSell.entrust_failed": "委托失败",
  "system.TradeSell.entrust_success": "委托成功",
  "system.TradeSell.funding_unique_id_not_exists": "配资唯一标示不存在",
  "system.TradeSell.individual_stock_position_exceeds_limit": "个人单支股票累计持仓超过限额",
  "system.TradeSell.loss_exceeds_warning_line_trading_prohibited": "亏损超过预警线禁止交易",
  "system.TradeSell.market_closed_cannot_trade": "休市时间,无法交易",
  "system.TradeSell.max_min_price_limit_exceeded": "最高最低买卖价格收盘价的9倍或9分之一",
  "system.TradeSell.please_enter_sell_quantity": "请输入出售数量",
  "system.TradeSell.please_enter_stock_code": "请输入股票代码",
  "system.TradeSell.please_enter_trade_quantity": "请输入交易数量",
  "system.TradeSell.position_info_not_exists": "持仓信息不存在",
  "system.TradeSell.purchase_failed": "购买失败",
  "system.TradeSell.sell_price_format_error": "出售价位格式错误",
  "system.TradeSell.sell_quantity_format_error": "出售数量格式错误",
  "system.TradeSell.sell_stock_failed": "出售股票失败",
  "system.TradeSell.sell_stock_success": "出售股票成功",
  "system.TradeSell.stock_not_open_for_trading": "此股票暂未开放交易",
  "system.TradeSell.stock_temporarily_unavailable": "股票暂时无法交易",
  "system.TradeSell.stock_today_trading_restricted": "此股票今日限制交易",
  "system.TradeSell.stock_trading_suspended": "此股票暂停交易",
  "system.TradeSell.today_tradeable_quantity_insufficient": "今日可交易数量不足",
  "system.WebNozzle.android_download": "安卓下载",
  "system.WebNozzle.apple_android_download": "苹果/安卓下载",
  "system.WebNozzle.ios_download": "Ios下载",
  "system.WebNozzle.wechat_official_account": "关注微信公众号",
  "system.WebNozzle.wechat_subscription_account": "关注微信订阅号",
  "system.Withdraw_model.fund_withdrawal": "资金提现",
  "system.Withdraw_model.status_completed": "已完成",
  "system.Withdraw_model.status_rejected": "已驳回",
  "system.Withdraw_model.status_under_review": "审核中",
  "system.YuebaoFund.account_insufficient_balance": "账户余额不足",
  "system.YuebaoFund.account_not_found": "没找到余额宝账户",
  "system.YuebaoFund.fund_transfer_in_failed": "资金转入失败",
  "system.YuebaoFund.fund_transfer_in_success": "资金转入成功",
  "system.YuebaoFund.fund_transfer_out_failed": "资金转出失败",
  "system.YuebaoFund.fund_transfer_out_success": "资金转出成功",
  "system.YuebaoFund.investment_balance_insufficient": "可投资余额不足",
  "system.YuebaoFund.modify_success": "修改成功",
  "system.YuebaoFund.no_settlement_document_selected": "没有选择结算单据",
  "system.YuebaoFund.please_enter_amount": "请输入金额",
  "system.YuebaoFund.please_enter_correct_amount": "请输入正确的金额",
  "system.YuebaoFund.settlement_document_not_found": "没有找到结算单据",
  "system.YuebaoFund.settlement_failed": "结算失败",
  "system.YuebaoFund.settlement_success": "结算成功",
  "system.YuebaoFund.transferable_amount_insufficient": "可转金额不足",
  "system.YuebaoFund.transferred_to_yuebao_failed": "转入余额宝理财失败",
  "system.YuebaoFund.transferred_to_yuebao_success": "已转入余额宝理财",
  "pc.trading.you_have_not_selected_quantity_for_sale": "您未选择卖出数量",
  "pc.trading.you_have_not_selected_any_stocks": "您未选择股票",
  "pc.trading.confirm_transaction": "确认交易",
  "pc.trading.are_you_sure_sell_this_stock": "您是否确认卖出该股票?",
  "pc.trading.sale_and_puchase_cancelled": "已取消卖出入",
  "pc.trading.you_have_not_selected_quantity_to_purchase": "您未选择购买数量",
  "pc.trading.are_you_sure_purchase_this_stock": "您是否确定买入该股票?",
  "pc.trading.purchase_has_been_cancelled": "已取消买入",
  "pc.trading.you_have_not_logged_in_please_login_before_purchase": "您还未登录,请先去登录后在操作购买",
  "pc.trading.you_have_not_logged_in_please_login_before_sale": "您还未登录,请先去登录后在操作卖出",
  "pc.trading.stock_has_not_purchased_please_buy_this_stock": "还未购买此股票,请进入购买页面购买此股票",
  "pc.operate.day_explain": "最少1千,最多200万,1百整倍数",
  "pc.operate.week_explain": "最少1千,最多200万,1百整倍数",
  "pc.operate.month_explain": "最少1千,最多200万,1百整倍数",
  "pc.operate.interest_free_explain": "最少1千,最多200万,1百整倍数",
  "pc.operate.vip_explain": "最少10万w,最多2000万w,1百整倍数",
  "pc.news_details.latest_articles": "最新文章",
  "pc.news_details.previous_item": "上一条",
  "pc.news_details.next_item": "下一条",
  "system.Member.please_contact_service_to_obtain_your_card_number": "请联系在线客服获取卡号",
  "system.Offline.success": "成功",
  "pc.capital.contact_our_online_customer_service": "联系在线客服",
  "pc.capital.recharge.recharge_has_popup_confirm_button": "继续新充值",
  "pc.capital.recharge.recharge_has_popup_cancel_button": "非新充值",
  "pc.capital.topuptransit.success_popup": "请确认您已付款！重复提交会影响到账时间",
  "pc.capital.select_recharge_method": "请选择充值方式",
  "pc.capital.withdraw_has_popup_content": "您已提交一笔同金额的提现正在审核处理中 若非新提现请勿重复提交",
  "pc.capital.withdraw.withdraw_has_popup_confirm_button\t": "继续新提现",
  "pc.capital.withdraw.withdraw_has_popup_cancel_button": "非新提现",
  "pc.couponinfo.user_coupon.fail_message": "请稍后尝试,提示",
  "pc.operate.margin_trading_rules": "配资交易规则",
  "pc.timebao.first_page": "已经是第一页",
  "pc.timebao.last_page": "已经是最后一页",
  "pc.table.no_data": "暂无数据",
  "el.select.noData": "无数据",
  "el.table.emptyText": "暂无数据",
  "el.select.loading": "加载中",
  "pc.allhkstock.totalMarketValue": "总市价 (万亿)",
  "pc.allhkstock.tradingVolume": "成交量 ( 百万)",
  "pc.allhkstock.sort_chg_desc": "涨幅榜 ",
  "pc.allhkstock.sort_chg_asc": "跌幅榜",
  "pc.allhkstock.sort_market_value_desc": "市价榜",
  "pc.allhkstock.sort_volume_desc": "成交量榜",
  "pc.myaccount.platform_transfer": "资金划转 ",
  "pc.platformtransfer.dnzq": "金牛证券",
  "pc.platformtransfer.dnhk": "金牛港股",
  "pc.platformtransfer.transfer_to": "划转至",
  "pc.platformtransfer.currency": "美元",
  "pc.platformtransfer.order_number": "订单号",
  "pc.platformtransfer.central_system_number": "中央系统编号",
  "pc.platformtransfer.transfer_amount": "划转额",
  "pc.platformtransfer.account_balance": "账户余额",
  "pc.platformtransfer.transfer_operation_type": "划转操作类型",
  "pc.platformtransfer.accessed_platform": "访问平台",
  "pc.platformtransfer.create_time": "创建时间",
  "system.platformtransfer.central_config": "稳定币配置已关闭，请联系客户服务",
  "system.platformtransfer.only_two_decimals": "仅允许 2 位小数",
  "pc.trading.short_sell_close_position": "做空平仓",
  "pc.trading.short_selling": "做空开仓",
  "pc.trading.can_be_purchase": "可平",
  "pc.trading.open_long_possition": "做多开仓",
  "pc.trading.closing_long_possition": "做多平仓",
  "pc.trading.can_be_close": "可平",
  "pc.trading.market_open": "交易中",
  "pc.trading.market_close": "休市中",
  "pc.header.capital_accounts": "配资账户",
  "pc.cuc.amount_received": "到账金额",
  "pc.cuc.dn_currency": "元 ",
  "pc.cuc.hk_currency": "港元 ",
  "pc.allhkstock.short_trading_stocks": "今日可做空股",
  "pc.allhkstock.long_trading_stocks": "今日可做多股",
  "system.RiskControls.system_is_busy": "当前系统繁忙，请稍后再试 ",
  "system.TradeSell.stock_transaction_failed": "该股票交易失败",
  "system.platformtransfer.transfer_failed_account_holder_not_match": "资金划转失败--- 转入转出账号主体信息不匹配，划转失败",
  "pc.tradingquery.trade_direction": "仓位方向",
  "pc.operate.direction_capital": "配资仓位方向",
  "pc.operate.long": "做多交易",
  "pc.operate.short": "做空交易",
  "pc.stockrise.currency": "亿美元",
  "pc.trading.trading_activity_fee": "交易活动费",
  "pc.trading.direction": "方向",
  "pc.trading.order": "订单",
  "pc.trading.open_position": "开平",
  "system.TradeBuy.daily_limit_open_error": "该子账户已达到单天开仓次数",
  "system.TradeBuy.single_stock_ratio_error": "已超过单股持仓比例",
  "pc.quotes.stock_rise1": "道琼斯工业指数",
  "pc.quotes.stock_rise2": "标准普尔500指数",
  "pc.quotes.stock_rise3": "纳斯达克指数",
  "pc.trading.stock_cannot_be_traded": "该股票不能在此平台上交易"
}


// WEBPACK FOOTER //
// ./src/assets/language/zh.js